import axios from "axios";
import { handleInvalidTokenLogout, isInvalidTokenResponse } from "./authSession";

const URL = process.env.REACT_APP_BASE_URL;

const Apiconnection = axios.create({
    baseURL: URL,
    headers: { 
        'Content-Type': 'application/json', 
        'X-Requested-With': 'XMLHttpRequest', 
    },
});

// Dynamically attach the latest auth token to every outgoing request
Apiconnection.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("prime_access_token");
        if (token) {
            config.headers = config.headers || {};
            config.headers['token'] = token;
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Intercept responses to detect invalid/expired token and automatically log out
Apiconnection.interceptors.response.use(
    (response) => {
        if (isInvalidTokenResponse(response?.data, response?.status, response?.config?.url)) {
            const message = response?.data?.message || 'Invalid Token!';
            handleInvalidTokenLogout(message);
            return Promise.reject(new Error(message));
        }
        return response;
    },
    (error) => {
        const responseData = error?.response?.data;
        const statusCode = error?.response?.status;
        const requestUrl = error?.config?.url;

        if (isInvalidTokenResponse(responseData, statusCode, requestUrl)) {
            const message = responseData?.message || 'Invalid Token!';
            handleInvalidTokenLogout(message);
        }
        return Promise.reject(error);
    }
);

export default Apiconnection;